import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import { siteConfig } from '@/mocks/siteData';
import BrandIntro from './components/BrandIntro';
import Values from './components/Values';
import Reputation from './components/Reputation';
import ContactForm from './components/ContactForm';

export default function About() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: `关于我们 - ${siteConfig.name}`,
    description: siteConfig.description,
    url: 'https://jiejiefriends.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: siteConfig.name,
      url: 'https://jiejiefriends.com',
    },
    about: {
      '@type': 'Organization',
      name: siteConfig.name,
      description: siteConfig.description,
      email: siteConfig.email,
      foundingDate: siteConfig.founded,
      url: 'https://jiejiefriends.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6 max-w-6xl mx-auto py-12 md:py-16">
            <div className="mb-4">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: '关于我们' },
                ]}
              />
            </div>
            <h1 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mt-3">
              关于我们
            </h1>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
              了解「姐姐的朋友」背后的故事、价值观和团队，认识我们如何帮助你打开优质社交圈。
            </p>
          </div>
        </div>

        <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
          <BrandIntro />
          <Values />
          <Reputation />
          <ContactForm />
        </div>
      </main>
      <Footer />
    </>
  );
}